import React from 'react';

var PlanDirections = React.createClass({

  render: function(){
    var data = this.props.directions;
    
    if (data) {
      var iOS = /(iPad|iPhone|iPod)/g.test( navigator.userAgent );
      var mapService = iOS ? 'apple' : 'google';
      var mapsLink = "http://maps." + mapService + ".com/?saddr=" + data.from.name + "," + data.from.address + "&daddr=" + data.to.name + "," + data.to.address; 

      var walkingDistance = data.walking.distance.text;
      var walking = (data.walking.duration.text !== '') ? <span>, <i className="fa fa-street-view" style={{ marginRight: -3 }}></i> {data.walking.duration.text}</span> : null;
      var transit = (data.transit.duration.text !== '') ? <span>, <i className="fa fa-subway"></i> {data.transit.duration.text}</span> : null;
      var driving = (data.driving.duration.text !== '') ? <span>, <i className="fa fa-car"></i> {data.driving.duration.text}</span> : null;
      var lunchbreakNext = this.props.lunchbreakNext;
      var lunchbreakElem = (lunchbreakNext) ? <div className="col-xs-6 col-sm-4 col-md-6 lunch"><i className="fa fa-coffee"></i> Lunch Break</div> : null;
      var linksClass = 'col-xs-12 links';
      linksClass = (lunchbreakNext) ? ('col-xs-6 col-sm-8 col-md-6 links')  : linksClass;
      
      if (this.props.isSmallScreen) {
        return (
            <div className="bar text-center directions row">
            {lunchbreakElem}
            <div className={linksClass}>
            <a target="_blank" className="locationMapLink url" href={mapsLink}>
            {walkingDistance}
            {driving}
            <i className="fa fa-arrow-down"></i></a>
            </div>
	    </div>
        );
      }
      
      return (
          <div className="bar text-center directions row">
          {lunchbreakElem}
	  <div className={linksClass}>
          <a target="_blank" className="locationMapLink url" href={mapsLink}>
            <i className="fa fa-arrows-v"></i>
            {walkingDistance}
            {driving}
            {transit}
            {walking}
          </a>
          </div>
	</div>
      );
    }
    return null;
  }
});

module.exports = PlanDirections;



// WEBPACK FOOTER //
// ./components/plan-directions.js